module.exports = __webpack_public_path__ + "img/secondary-button-background-color.d7aaa7d5.svg";